<template>
  <a-modal
    title="文件预览"
    :dialog-style="{ top: '0', overflow: 'hidden' }"
    :bodyStyle="{ height: 'calc(100vh - 55px)' }"
    v-model="previewVisible"
    centered
    :footer="null"
    :maskClosable="false"
    destroyOnClose
    width="1200px"
    @cancel="
      () => {
        this.$emit('previewFileClose');
      }
    "
  >
    <div id="filePreview" style="width: 100%; height: 100%; text-align: center">
      <a-spin :spinning="spinning" tip="预览文件加载中..." />
    </div>
  </a-modal>
</template>

<script>
import WebOfficeSDK from "@/assets/js/web-office-sdk-solution-v1.1.27.es";
export default {
  name: "previewCreateFile",
  props: {
    fileId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      previewVisible: false,
      spinning: false,
    };
  },
  methods: {
    previewFile() {
      let _this = this;
      _this.previewVisible = true;
      _this.spinning = true;
      _this.axios
        .post("/manuscriptsAddFile/queryByCode", {
          codes: [_this.fileId],
        })
        .then((res) => {
          if (res.data.code == "OK") {
            if (res.data.data[0].previewUrl) {
              _this.$confirm({
                title: "提示",
                content: "预览文件已存在是否重新生成？",
                okText: "重新生成",
                cancelText: "直接预览",
                onOk: () => {
                  _this.createFilePreview();
                },
                onCancel: () => {
                  _this.getFilePreview();
                },
              });
            } else {
              _this.createFilePreview();
            }
          } else {
            _this.$notification["warning"]({
              message: "提示",
              description: res.data.data,
            });
          }
        });
    },
    createFilePreview() {
      let _this = this;
      _this.axios
        .get("/manuscripts/createPreviewFile", {
          params: {
            code: _this.fileId,
            time: new Date().getTime(),
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            _this.getFilePreview();
          } else {
            _this.$notification["warning"]({
              message: "提示",
              description: res.data.data,
            });
          }
        });
    },
    // 获取web预览文件地址
    async getFilePreview() {
      let _this = this;
      const instance = WebOfficeSDK.init({
        officeType: WebOfficeSDK.OfficeType.Writer,
        appId: _this.$config.wpsAppId,
        fileId: _this.fileId + "_preview",
        token: "CCSJiXMpPIibHJxDaJPa",
        mount: "#filePreview",
        customArgs: {
          userCode: sessionStorage.getItem("userCode"),
          readOnly: "true",
          appKey: _this.$config.appKey,
        },
        wordOptions: {
          isShowDocMap: false, // 是否开启目录功能，默认开启
          isBestScale: false, // 打开文档时，默认以最佳比例显示
          isShowBottomStatusBar: false, // 是否展示底部状态栏
        },
      });
      _this.spinning = false;
      await instance.ready();
    },
  },
};
</script>

<style>
</style>